var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('app-header'),_vm._t("breadcrumb"),_vm._t("slider"),_c('div',{staticClass:"site-main"},[_vm._t("main-content")],2),_c('app-footer'),_c('app-back-to-top')],2)}
var staticRenderFns = []

export { render, staticRenderFns }